// The attribute_changed inputs offer "None" as a choice; it travels as a
// sentinel so it survives the array round-trip and becomes null on the wire.
export const ATTRIBUTE_CHANGED_EMPTY_VALUE = '__empty__';

const extractOptionValue = value =>
  value && typeof value === 'object' ? value.id : value;

const setArrayValues = values => values.map(extractOptionValue);

const setAttributeChangedValues = values => {
  const normalize = side =>
    (Array.isArray(values?.[side]) ? setArrayValues(values[side]) : []).map(
      value => (value === ATTRIBUTE_CHANGED_EMPTY_VALUE ? null : value)
    );

  return { from: normalize('from'), to: normalize('to') };
};

const generateValues = item => {
  if (item.filter_operator === 'attribute_changed') {
    return setAttributeChangedValues(item.values);
  }
  if (Array.isArray(item.values)) {
    return setArrayValues(item.values);
  }
  if (typeof item.values === 'object') {
    return item.values?.id ? [item.values.id] : [];
  }
  if (!item.values) {
    return [];
  }
  return [item.values];
};

const generatePayload = data => {
  // Make a copy of data to avoid vue data reactivity issues
  const filters = JSON.parse(JSON.stringify(data));
  let payload = filters.map(item => {
    item.values = generateValues(item);
    return item;
  });

  // For every query added, the query_operator is set default to and so the
  // last query will have an extra query_operator, this would break the api.
  // Setting this to null for all query payload
  payload[payload.length - 1].query_operator = undefined;
  return { payload };
};

export default generatePayload;
